import { IListagemArquivosState } from './interfaces/IListagemArquivosState';
import {
  ListagemArquivosActionUnion,
  ListagemArquivosActionKeys,
} from './ListagemArquivos.actions';
import { IProgressDownloading } from '../../Data/interfaces/Obra/IDownloadFilesRequest';

const initialState: IListagemArquivosState = {
  filters: {
    showTipo: false,
    showVisualization: false,
    showStatus: false,
    showVersions: false,
    showModificado: {
      show: false,
      showDropdown: false,
      showData: false,
      showUsers: false,
    },
  },
  editFormIndex: [],
  showEditTable: false,
  showPlotRequestTable: false,
  selectedEditRowKeys: [],
  selectedPlotRequestRowKeys: [],
  isLoading: false,
  showModalDeleteFiles: false,
  showModalCreateFolder: false,
  showModalInfoFiles: false,
  showModalDownloadMultipleFiles: false,
  hasFolderModalDownload: false,
  downloadFileList: undefined,
  progressDownload: {} as IProgressDownloading,
  currentUserPrivileges: undefined,
  showInfoCard: false,
};

const listagemArquivos = (
  state = initialState,
  action: ListagemArquivosActionUnion,
): IListagemArquivosState => {
  switch (action.type) {
    // DOWNLOAD
    case ListagemArquivosActionKeys.DOWNLOAD_FILES_REQUEST:
      return {
        ...state,
        downloadFileList: action.payload,
        isLoading: true,
        isDownloading: true,
      };
    case ListagemArquivosActionKeys.DOWNLOAD_FILES_SUCCESS:
      const progressBar = {
        total: 1000,
        loaded: 0,
      };
      return {
        ...state,
        isLoading: false,
        isDownloading: false,
        progressDownload: progressBar,
      };
    case ListagemArquivosActionKeys.DOWNLOAD_FILES_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
        isDownloading: false,
      };
    case ListagemArquivosActionKeys.PROGRESS_DOWNLOAD:
      return {
        ...state,
        progressDownload: action.payload,
      };

    case ListagemArquivosActionKeys.SET_SHOW_EDIT_TABLE:
      return {
        ...state,
        showEditTable: action.payload,
      };

    case ListagemArquivosActionKeys.SET_SHOW_PLOT_REQUEST_TABLE:
      return {
        ...state,
        showPlotRequestTable: action.payload,
      };

    case ListagemArquivosActionKeys.SET_SHOW_MODAL_DELETE_FILES:
      return {
        ...state,
        showModalDeleteFiles: action.payload,
      };

    case ListagemArquivosActionKeys.SET_SHOW_MODAL_CREATE_FOLDER:
      return {
        ...state,
        showModalCreateFolder: action.payload,
      };
    case ListagemArquivosActionKeys.SET_SHOW_MODAL_INFO_FILES:
      return {
        ...state,
        showModalInfoFiles: action.payload,
      };
    case ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_TIPO:
      return {
        ...state,
        filters: {
          ...state.filters,
          showTipo: action.payload,
        },
      };

    case ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_VISUALIZATION:
      return {
        ...state,
        filters: {
          ...state.filters,
          showVisualization: action.payload,
        },
      };

    case ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_STATUS:
      return {
        ...state,
        filters: {
          ...state.filters,
          showStatus: action.payload,
        },
      };

    case ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_VERSIONS:
      return {
        ...state,
        filters: {
          ...state.filters,
          showVersions: action.payload,
        },
      };

    case ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_MODIFICADO:
      return {
        ...state,
        filters: {
          ...state.filters,
          showModificado: {
            show: action.payload.show,
            showDropdown: action.payload.showDropdown,
            showData: false,
            showUsers: false,
          },
        },
      };

    case ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_MODIFICADO_DATA:
      return {
        ...state,
        filters: {
          ...state.filters,
          showModificado: {
            show: true,
            showDropdown: false,
            showData: action.payload,
            showUsers: false,
          },
        },
      };

    case ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_MODIFICADO_USERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          showModificado: {
            show: true,
            showDropdown: false,
            showData: false,
            showUsers: action.payload,
          },
        },
      };

    case ListagemArquivosActionKeys.SET_EDIT_FORM_INDEX:
      let newEditArray: number[] = [];
      if (state.editFormIndex.includes(action.payload) === true) {
        newEditArray = state.editFormIndex.filter((item) => item !== action.payload);
      }
      if (state.editFormIndex.includes(action.payload) === false) {
        newEditArray = [...state.editFormIndex, action.payload];
      }
      return {
        ...state,
        editFormIndex: newEditArray,
      };

    case ListagemArquivosActionKeys.SET_SELECTED_EDIT_ROW_KEYS:
      return {
        ...state,
        selectedEditRowKeys: [...action.payload],
      };

    case ListagemArquivosActionKeys.SET_SELECTED_PLOT_REQUEST_ROW_KEYS:
      return {
        ...state,
        selectedPlotRequestRowKeys: action.payload,
      };

    case ListagemArquivosActionKeys.SET_SHOW_MODAL_DOWNLOAD_MULTIPLE_FILES:
      return {
        ...state,
        showModalDownloadMultipleFiles: action.payload.isVisible,
        hasFolderModalDownload: action.payload.hasFolder || false,
      };

    case ListagemArquivosActionKeys.CURRENT_USER_PRIVILEGES:
      return {
        ...state,
        currentUserPrivileges: action.payload,
      };

    case ListagemArquivosActionKeys.TOOGLE_SHOW_INFO_CARD:
      return {
        ...state,
        showInfoCard: action.payload,
      };

    default:
      return state;
  }
};

export default listagemArquivos;
